import { render, staticRenderFns } from "./accountDescribe.vue?vue&type=template&id=6bdf78b1&scoped=true&"
import script from "./accountDescribe.vue?vue&type=script&lang=js&"
export * from "./accountDescribe.vue?vue&type=script&lang=js&"
import style0 from "./accountDescribe.vue?vue&type=style&index=0&id=6bdf78b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf78b1",
  null
  
)

export default component.exports